import type { VariantProps } from "class-variance-authority";
import { cva } from "class-variance-authority";
import type React from "react";
import { classNames } from "../../utils/classNames";

export const headingStyles = cva("", {
	variants: {
		kind: {
			h5: "font-medium text-neutral-faded text-xs",
			h4: "font-semibold text-neutral text-sm leading-5",
			h3: "font-semibold text-base text-neutral leading-5",
			h2: "font-semibold text-neutral text-xl leading-5",
			h1: "font-semibold text-2xl text-neutral leading-6",
		},
	},
	defaultVariants: {
		kind: "h3",
	},
});

export type HeadingProps = {
	children: React.ReactNode;
	kind?: VariantProps<typeof headingStyles>["kind"];
	As?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
	className?: string;
	style?: React.CSSProperties;
	id?: string;
};

export const Heading = ({ children, kind, As = "h2", className, style, id }: HeadingProps) => {
	return (
		<As id={id} className={classNames(headingStyles({ kind }), className)} style={style}>
			{children}
		</As>
	);
};
